if (!customElements.get('featured-product-widget')) {
  class FeaturedProductWidget extends HTMLElement {
    constructor() {
      super();

      this.addHandlers = this.querySelectorAll('.js-add-to-cart');

      this.addHandlers.forEach((handler) => {
        handler.addEventListener('click', (e) => {
          window.handlers['addProduct'](e.currentTarget.dataset.id);
        });
      });
    }
  }

  customElements.define('featured-product-widget', FeaturedProductWidget);
}
